export default {
  CREATED: 'created',
  ACTIVATING: 'activating',
  ACTIVATED: 'activated',
  ENDING: 'ending',
  ENDED: 'ended',
  CANCELLED: 'cancelled'
};